import React, { useContext, useState, useEffect } from "react";
// import RecordKeepingComponent from "./RecordKeepingComponent";
import style from "../Assets/css/dashboard_component.css";
import EURecordKeepingAnalyticsComponent from "./EURecordKeepingAnalyticsComponent";
import EURecordKeepingReportingComponent from "./EURecordKeepingReportingComponent";
import HeaderComponent from "./UI/HeaderComponent";
import FooterComponent from "./UI/FooterComponent";
import Tabs from "./UI/Tabs";
import AppContext from "../Store/AppContext";
import EURecordKeepingRTS22TransactionsComponent from "./EURecordKeepingRTS22TransactionsComponent";
import EURecordKeepingRTS24OrdersAndExecutionsComponent from "./EURecordKeepingRTS24OrdersAndExecutionsComponent";
import EURecordKeepingAnnexIVExecutionsComponent from "./EURecordKeepingAnnexIVExecutionsComponent";
import EURecordKeepingAnnexIVOrdersComponent from "./EURecordKeepingAnnexIVOrdersComponent";

const EURecordKeepingDashboardComponent = () => {
  const { regulationCode } = useContext(AppContext);
  const [navigationDetails, setNavigationDetails] = useState({
    to: "",
    data: {},
    time: "",
  });
  // console.log("dashboard :", regulationCode);

  const today = new Date();
  const sevenDaysAgo = new Date(today);
  sevenDaysAgo.setDate(today.getDate() - 7);
  const DATE_RANGE_STORAGE_KEY = `dateRange:${regulationCode}:EURecordKeeping`;

  const getInitialDateRange = (regulation) => {
    const storageKey = `dateRange:${regulation}:EURecordKeeping`;
    const saved = localStorage.getItem(storageKey);
    if (saved) {
      const [start, end] = JSON.parse(saved);
      return [new Date(start), new Date(end)];
    }
    return [sevenDaysAgo, today];
  };

  const [dateRangeByRegulation, setDateRangeByRegulation] = useState(() => ({
    [regulationCode]: getInitialDateRange(regulationCode),
  }));

  const [euRecordKeepingFilters, setEuRecordKeepingFilters] = useState({
    R001: "all",
    R002: "all",
    R003: "all",
  });
  console.log("euRecordKeepingFilters :", euRecordKeepingFilters);
  useEffect(() => {
    setDateRangeByRegulation((prev) => {
      if (prev[regulationCode]) return prev;
      return {
        ...prev,
        [regulationCode]: getInitialDateRange(regulationCode),
      };
    });
  }, [regulationCode]);

  const dateRange =
    dateRangeByRegulation[regulationCode] ||
    getInitialDateRange(regulationCode);
  const setDateRange = (nextRange) => {
    setDateRangeByRegulation((prev) => ({
      ...prev,
      [regulationCode]: nextRange,
    }));
  };

  const handleSetNavigationDetails = (navDetails) => {
    // console.log('nav details :', navDetails);
    setNavigationDetails(navDetails);
  };

  useEffect(() => {
    // set initial route for auth session
    if (dateRange?.[0] && dateRange?.[1]) {
      localStorage.setItem(DATE_RANGE_STORAGE_KEY, JSON.stringify(dateRange));
    }
  }, [dateRange, DATE_RANGE_STORAGE_KEY]);

  useEffect(() => {
    if (dateRange?.[0] && dateRange?.[1]) {
      localStorage.setItem(DATE_RANGE_STORAGE_KEY, JSON.stringify(dateRange));
    }
  }, [dateRange, DATE_RANGE_STORAGE_KEY]);

  return (
    <>
      <HeaderComponent visibility={true} />
      <div style={{ justifyContent: "space-between" }}>
        <Tabs
          navigationDetails={navigationDetails}
          setNavigationDetails={setNavigationDetails}
          keepMounted
        >
          <div className={style.tab1} label="Analytics">
            <EURecordKeepingAnalyticsComponent
              productCode="P004"
              regulationCode={regulationCode}
              dateRange={dateRange}
              setDateRange={setDateRange}
              navigationDetails={navigationDetails}
              handleSetNavigationDetails={handleSetNavigationDetails}
              sharedFilters={euRecordKeepingFilters}
              setSharedFilters={setEuRecordKeepingFilters}
            />
          </div>
          <div className="tab2" label="Reporting">
            <EURecordKeepingReportingComponent
              productCode="P004"
              regulationCode={regulationCode}
            />
          </div>
          <div className="tab2" label="Annex IV - Orders">
            <EURecordKeepingAnnexIVOrdersComponent
              productCode="P004"
              regulationCode="R002"
              dateRange={dateRange}
              setDateRange={setDateRange}
              navigationDetails={navigationDetails}
              sharedFilters={euRecordKeepingFilters}
              setSharedFilters={setEuRecordKeepingFilters}
            />
          </div>
          <div className="tab2" label="Annex IV - Executions">
            <EURecordKeepingAnnexIVExecutionsComponent
              productCode="P004"
              regulationCode="R003"
              dateRange={dateRange}
              setDateRange={setDateRange}
              navigationDetails={navigationDetails}
              sharedFilters={euRecordKeepingFilters}
              setSharedFilters={setEuRecordKeepingFilters}
            />
          </div>
          <div className="tab2" label="RTS24 - Orders and Executions">
            <EURecordKeepingRTS24OrdersAndExecutionsComponent
              productCode="P004"
              regulationCode="R001"
              dateRange={dateRange}
              setDateRange={setDateRange}
              navigationDetails={navigationDetails}
              sharedFilters={euRecordKeepingFilters}
              setSharedFilters={setEuRecordKeepingFilters}
            />
          </div>
          <div className="tab2" label="RTS22 - Transactions">
            <EURecordKeepingRTS22TransactionsComponent
              productCode="P004"
              regulationCode="R004"
            />
          </div>
        </Tabs>
      </div>
      <FooterComponent />
    </>
  );
};

export default EURecordKeepingDashboardComponent;
